import { stopVideos } from './stop-playback-implementation';

export async function runStopVideoImplementation(data: {
  target?: { id?: string };
}) {
  const targetId = data?.target?.id;
  if (!targetId) return;
  stopVideos({ allTargets: false, targetId });
}

export async function runStopAllVideosImplementation() {
  stopVideos({ allTargets: true });
}
